import { Api } from "common-components";
import { stringify } from "query-string";

const omitEmpty = (payload) =>
	Object.entries(payload).reduce((acc, [key, value]) => {
		const isEmpty = Array.isArray(value) ? value.length === 0 : value === null || value === undefined || value === "";
		return isEmpty ? acc : { ...acc, [key]: value };
	}, {});

/**
 * 取得錯題回報查詢的搜尋條件選單
 */
export const getErrorReportSelection = async () => {
	const response = await Api.get(`${process.env.REACT_APP_DOMAIN}/api/questionerrorreport/selection`);
	return response;
};

/**
 * 分頁查詢錯題回報記錄
 *
 * @param {object} payload pagenumber、pagesize 與各篩選條件
 */
export const getErrorReportList = async (payload) => {
	const queryString = stringify(omitEmpty(payload));
	const response = await Api.get(`${process.env.REACT_APP_DOMAIN}/api/questionerrorreport/query?${queryString}`);
	return response;
};

/**
 * 查詢單一題目詳情（題目預覽）
 *
 * @param {string} eduSubject 學制科目代碼，取 query 回傳的 eduSubject
 * @param {string} questionUID 題號，取 query 回傳的 questionUID
 */
export const getErrorReportQuestion = async (eduSubject, questionUID) => {
	const response = await Api.get(
		`${process.env.REACT_APP_DOMAIN}/api/questionerrorreport/questions/${eduSubject}/${questionUID}`,
	);
	return response;
};

/**
 * 批次修改錯題回報狀態
 *
 * @param {object} payload UIDs 為回報單號（取 query 回傳的 UID，非題目 UID）、status 為狀態代碼
 */
export const updateErrorReportsStatus = async (payload) => {
	const response = await Api.put(`${process.env.REACT_APP_DOMAIN}/api/questionerrorreport/status`, payload);
	return response;
};

/**
 * 批次題目下架
 *
 * @param {object} payload UIDs 為回報單號、availabilities 為要下架的產品代碼
 */
export const deprecateErrorReportQuestions = async (payload) => {
	const response = await Api.put(
		`${process.env.REACT_APP_DOMAIN}/api/questionerrorreport/questions/deprecate`,
		payload,
	);
	return response;
};

/**
 * 批次寄送錯題回報通知信
 *
 * @param {object} payload UIDs 為回報單號
 */
export const sendErrorReportMails = async (payload) => {
	const response = await Api.post(`${process.env.REACT_APP_DOMAIN}/api/questionerrorreport/mail`, payload);
	return response;
};

/**
 * 批次修改錯題回報備註留言
 *
 * @param {object} payload UIDs 為回報單號、remark 為備註內容
 */
export const updateErrorReportsRemark = async (payload) => {
	const response = await Api.put(`${process.env.REACT_APP_DOMAIN}/api/questionerrorreport/remark`, payload);
	return response;
};

/**
 * 下載錯題回報報表（xlsx）
 *
 * NOTE: 成功時回傳 xlsx 檔案；失敗時一樣是 HTTP 200，但內容改為 ResponseDto JSON，需由呼叫端依 blob.type 判斷
 *
 * @param {object} payload UIDs 為回報單號（至少一筆）
 * @returns {Promise<Blob>}
 */
export const exportErrorReports = async (payload) => {
	const response = await Api.post(`${process.env.REACT_APP_DOMAIN}/api/questionerrorreport/export`, payload, {
		responseType: "blob",
	});
	return response;
};
